import { getLocalStorage } from './storage.js';
import { resolveRumEnv } from './datadogEnv';
import { shouldDiscardRumEvent } from './shouldDiscardRumEvent';

export default {
	applicationId: '633292a3-9da7-47e2-ac63-6f211a269d98',
	clientToken: 'pubf545178c85b44d2e28f26bfdfd051768',
	site: 'datadoghq.com',
	service: 'web-reg',
	version: import.meta.env.VITE_APP_VERSION,
	env: resolveRumEnv(window.Stash?.env),
	sessionSampleRate: 100,
	sessionReplaySampleRate: 20,
	trackUserInteractions: true,
	trackResources: true,
	trackLongTasks: true,
	defaultPrivacyLevel: 'mask-user-input',
	enableExperimentalFeatures: ['feature_flags'],
	compressIntakeRequests: true,
	allowedTracingUrls: getLocalStorage('allowTracingForPublicDomain')
		? [/https:\/\/.*\.stsh\.io/, /https:\/\/.*\.stash\.com/]
		: [/https:\/\/.*\.stsh\.io/],
	// v7 sends a baggage header by default. Traced origins do not allow it yet.
	propagateTraceBaggage: false,
	beforeSend: (event) => !shouldDiscardRumEvent(event),
};
